/**
 * Адрес Supabase, в который ходит фронт.
 *
 * Раньше здесь лежали две константы, и образ у боевого стенда и у тестового
 * был один и тот же — значит тест ходил в боевую базу. Проверить на нём
 * миграцию или новый раздел было нельзя: любая проверка шла по живым данным.
 *
 * Теперь адрес задаётся на сборке. Значения по умолчанию — боевые: сборка без
 * переменных собирается ровно как раньше, и забытая переменная не уводит прод
 * на тестовый проект, а в худшем случае оставляет тест на бою — то есть ведёт
 * себя как до этой правки, а не хуже.
 *
 * Ключ здесь публичный (anon / publishable): он уезжает в браузер каждому
 * пользователю и секретом не является. Сервисный ключ сюда класть нельзя.
 */

const PROD_PROJECT_ID = 'ypmccadaepjdsqazieyc';
const PROD_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlwbWNjYWRhZXBqZHNxYXppZXljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgyODgzNjcsImV4cCI6MjA3Mzg2NDM2N30.MtTXqxb0geMB-_C38sVHplSyM0pYgcj0X0W2z_l1ggU';

const env = import.meta.env as Record<string, string | undefined>;

export const projectId = env.VITE_SUPABASE_PROJECT_ID || PROD_PROJECT_ID;
export const publicAnonKey = env.VITE_SUPABASE_ANON_KEY || PROD_ANON_KEY;

/** Собран ли этот образ против боевого проекта. Отвечает за это сборка, не хост. */
export const isProdProject = projectId === PROD_PROJECT_ID;
